module.exports = __webpack_public_path__ + "images/7388a17e6ca6f29f708ad46441319d88.png";